/**
 * Proven By Design — Mobile layout v2
 * Revert: disable section setting or delete this file.
 */
function initProvenMobileV2() {
  document.querySelectorAll('.proven-section--mobile-v2').forEach(function (section) {
    section.querySelectorAll('[data-effective-support]').forEach(function (block) {
      var inner = block.querySelector('.effective-inner');
      var toggle = block.querySelector('[data-effective-toggle]');
      if (!inner || !toggle) return;

      var tags = inner.querySelectorAll('.txt-14');
      var extraCount = tags.length - 2;

      if (extraCount <= 0) return;

      tags.forEach(function (tag, index) {
        if (index >= 2) tag.classList.add('effective-tag--hidden');
      });

      toggle.textContent = '+' + extraCount + ' more';
      toggle.addEventListener('click', function () {
        var expanded = block.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        toggle.textContent = expanded ? 'Show less' : '+' + extraCount + ' more';
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', initProvenMobileV2);
